// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "LoginPage" + "." + "c33f83b4" + ".chunk.css";
};